import React, { useState } from "react";
import moment from 'moment';
import './withdrawal.scss';

import Button from '../../../Form/Button/Button';
import { formatCurrency } from '../../../../utils/helpers';
import withFeatureFlags from '../../../FeatureFlags/withFeatureFlags';
import ButtonGroup from "../../../Form/Button/ButtonGroup";
import Positive from '../../../../assets/images/Positive.svg';

/** @import {NoticePeriod} from "./indexTypes" */
/** @import {SuccessStepProps} from "./SuccessStepTypes" */
/** @import {WithFeatureFlagsProps} from "../../../FeatureFlags/FeatureFlagsTypes" */

import './withdrawal.scss';
import {useUnifiedAnalytics} from "../../../../contexts/AnalyticsWrapper";

function SuccessStep(/** @type {SuccessStepProps & WithFeatureFlagsProps} */ props) {
    const {
        onConfirm,
        balance,
        amount,
        keepOrCloseAccount,
        productName,
        noticePeriod,
        selectedAccount,
        isNoticeWithdrawal,
    } = props;

    const analytics = useUnifiedAnalytics();

    const onSubmitClicked = async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();
        const typeOfWithDrawal = balance === 0 ? keepOrCloseAccount : 'partial';
        const flowName = `ns ${typeOfWithDrawal} withdrawal done`;

        if (isNoticeWithdrawal){
            analytics.trackAnalyticsClickEvent(
                flowName,
                window.location.href,
                'dashboard',
                'notice-saver',
                'ns withdrawal journey',
                {},
                'link click',
                `transaction|${flowName}|ns withdrawal`,
                'ns withdrawal journey'
            );

        }

        if (typeof onConfirm === 'function') await onConfirm(event);
        return false;
    };

    const calculatePaymentDate = (/** @type {NoticePeriod} */ noticePeriod, /** @type {boolean} */ longFormat) => {
        let d = moment()
        if (noticePeriod && noticePeriod.length && noticePeriod.length > 0) {
            d.add(noticePeriod.length, /** @type {any} */ (noticePeriod.unit));
        }
        return d.format(longFormat ? "D MMMM YYYY" : "DD/MM/YY")
    }

    return (
        <form className="withdrawal withdrawal--step-2">
            <div className="withdrawal__section withdrawal__section--success">
                <div className="withdrawal__product">
                    <img src={Positive} className="withdrawal__tick"/>
                    <h3 className="withdrawal__title">Success!</h3>
                </div>
                {!isNoticeWithdrawal && <div className="withdrawal__balance">
                    <span className="withdrawal__balance-key">Withdrawal of</span>
                    <span className="withdrawal__balance-value">{amount ? formatCurrency(amount) : ""}</span>
                </div>}
                {isNoticeWithdrawal && <div className="withdrawal__balance">
                    <span className="withdrawal__balance-key">Your {amount ? formatCurrency(amount) : ""} withdrawal has been scheduled.</span>
                </div>}
            </div>
            <div className="withdrawal__divider"/>
            <div className="withdrawal__section withdrawal__section--success">
                <div className="withdrawal__line"><strong>From</strong> {productName}</div>
                <div className="withdrawal__line"><strong>To</strong> {selectedAccount?.name || selectedAccount?.label}</div>
            </div>
            <div className="withdrawal__divider" />
            <div className="withdrawal__section">
                <div className="withdrawal__section--horizontal-top">
                    <div className="">
                        <div className="withdrawal__line"><strong>Withdrawal date</strong> {noticePeriod ? calculatePaymentDate(noticePeriod, true || 0) : ""}</div>
                        <div className="withdrawal__line"><strong>Available balance</strong> {formatCurrency(balance)}</div>
                    </div>

                    <ButtonGroup noGutter>
                        <Button size='med' onClick={onSubmitClicked} type="submit" label="Done" />
                    </ButtonGroup>
                </div>
            </div>
        </form>
    );
}

export default withFeatureFlags(SuccessStep);